<div class="dialog-close">
    <button mat-icon-button mat-dialog-close>
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<mat-dialog-content>
    <app-enrollment-form
        [formGroup]="formGroup"
        [enrollment]="data.enrollment"
        [countries]="data.countries"
        [enrollmentProvinces]="data.enrollmentProvinces"
        [enrollmentTypes]="data.enrollmentTypes"
        (onSubmitEvent)="submit()">
    </app-enrollment-form>
</mat-dialog-content>
